import React from 'react'
import { Modal, Icon } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import { routes } from 'routes/Routes';
import _StudentService from '../modules/StudentService';
import MyInput from 'components/controls/MyInput';
import InputCheck from 'components/controls/InputCheck';
import DropdownList from 'components/controls/DropdownList';
import Button from 'components/controls/Button';
import DatePicker from 'components/controls/DatePicker';
// Stage 3.4 (Enterprise Registration Page Modernization): the Stage 3.2 shared Card now wraps each
// of this page's 7 form sections — see
// frontendDesign/Stage_3_4/Implementation/ERPM_S3_4_Component_Usage.md. `TextArea` removed from the
// import list above — confirmed unused anywhere in this file (matches the pre-existing ESLint
// warning for this exact file/line).
import Card from 'components/enterprise/Card';

import captchaReload from "assets/img/captcha_reload.png";
import _AdminService from 'modules/AdminService';
import PublicFooter from "../components/Footer/PublicFooter";
import _validator from 'modules/validator';
import _authService from 'modules/AuthService';
import _notification from 'modules/notification';
import _EnterpriseOpsService from 'modules/EnterpriseOpsService';
import IdentityVerificationPanel from 'components/enterprise/IdentityVerificationPanel';
import moment from 'moment';
import "assets/css/Registration.css"

import { token, otpResendTimeout, OTP_GENERATION_LIMIT, OTP_LIMIT_ERROR_MSG } from '../constants/constants';
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Stage 3.9 (Task 2/5): validation messages are set via setState with a plain string, so they use the
// plain resolveText() helper — see NewLogin.jsx's identical comment for why.
function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

export default class Registration_new extends React.Component {

    constructor(props) {
        super(props);
        // Phase C.7.4C (§9 Privacy Policy/Terms & Conditions drawer experience): reuses PublicFooter's
        // own existing Drawer/showDrawer()/getPortalConfigurationByKey() mechanism via a ref — the
        // exact same pattern LandingPage_new_one.jsx's "Important Links" card already established
        // (see its own footerRef/showDrawer usage) — instead of duplicating a second drawer
        // implementation. No new content source, no new component.
        this.footerRef = React.createRef();
        this.state = {
            isLoading: false,
            postList: [],
            categoryList: [],

            // form fields
            Applied_PostId: 0,
            Exam_ErrorError: '',

            firstName: '',
            firstNameError: "",

            lastName: '',
            lastNameError: "",

            email: '',
            emailError: "",

            phoneNumber: '',
            phoneNumberError: "",

            password: "",
            passwordError: "",

            passwordConfirm: "",
            passwordConfirmError: "",

            Birth_Date: null,
            Birth_DateError: "",

            Aadhaar_Number: '',
            Aadhaar_NumberError: '',
            Aadhaar_NumberConfirm: '',
            Aadhaar_NumberConfirmError: '',

            // Sprint 2.6.1 (Enterprise Identity Modernization): Mobile OTP + Email OTP, the active
            // identity-verification mechanism replacing Aadhaar above. Flags are admin-configurable
            // (EnterpriseConfiguration FeatureFlag: MobileOtpVerification/EmailOtpVerification).
            mobileOtpVerificationEnabled: false,
            emailOtpVerificationEnabled: false,
            identityVerificationToken: null,

            captchaText: '',
            captchaTextError: '',

            karyalayinKamkaj: false,

            categoryId: 0,
            categoryIdError: '',
            examFee: 0,
            showCategory: false,
            showAadharMandatory: false,
            showKaryalayinKamgar: false,

            config: {},

            captcha: {},

            showExServiceManCheckBox: false,
            showHandicapCheckBox: false,
            showMahilaReservationCheckBox: false,
            ShowShowEarthquakeCheckBox: false,
            ShowProjectAffectedCheckBox: false,
            ShowPlayerCheckBox: false,
            ShowAnshkalinCheckBox: false,
            ShowOrphanCheckBox: false,

            Ex_Serviceman: false,
            Is_Handicaped: false,
            Is_Ladies: false,
            Earth_Quake_Affected: false,
            Is_Praklapgast: false,
            Is_Player: false,
            Is_Anshkalin: false,
            Is_Orphan: false,

            IsScribeRequired: false,

            is_DateConfirm: false,
            is_DateConfirmError: '',
            // Sprint 2.2 (Privacy & Consent Foundation)
            is_ConsentAccepted: false,
            is_ConsentAcceptedError: '',
            // Registration-blocker fix: the Register button's `disabled` prop already gated on
            // identityVerificationToken whenever Mobile/Email OTP verification is enabled, but
            // handleRegistration() itself never checked it and nothing ever told the candidate WHY the
            // button stayed disabled (unlike is_DateConfirm/is_ConsentAccepted, which both surface an
            // inline error). This mirrors that existing pattern for the identity-verification gate.
            identityVerificationError: '',
            showModal: false,
            resData: {},
            registrationDisable: false,
            client_id: "",
            OTP_Number: "",
            OTP_NumberError: "",
            OTP_NumberSucess: "",
            isSuccess: false,

            AadharNumber: "",
            StatusCode: " ",
            MessageCode: "",
            Sucess: false,

            aadharOtpVerity: false,
            isButtonDesable: false,

            otpButtonDisabled: false,
            remainingTime: 0,
            LogCount: 0,
        }
        this.timerInterval = null;
    }

    componentWillUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }

    getInfo = async (ev) => {
        await _authService.clearSessionHist();

        this.setState({ isLoading: true });
        try {
            const response = await _authService.cachePortalConfiguration();
            if (response.status == 200 && response.data) {
                this.setState({ isLoading: false, resData: { ...response.data } })

                // Recruitment Candidate-List Publication Modernization phase: IsRegistrationClosed is
                // computed server-side (PortalConfigurationService) and folds in BOTH the pre-existing
                // manual is_Registration_Payment_Disabled kill-switch AND the new configured cutoff
                // date/time — checking it here, instead of the raw manual flag alone, means a scheduled
                // cutoff now also hides New Registration without any further frontend timezone logic.
                if (response && response.data && !response.data.IsRegistrationClosed) {
                    this.getIpAddress();
                }
                else {
                    this.registrationDisable();
                }

            }
            else {
                this.setState({ isLoading: false });
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            this.setState({ isLoading: false })

        }

    }

    componentDidMount() {
        this.getInfo();
        this.getConfigurationWithoutImage();
        this.getIdentityVerificationPolicy();
    }

    // Sprint 2.6.1 (Enterprise Identity Modernization): reads the two feature flags this sprint
    // introduces via the existing anonymous EnterpriseConfigController.IsFeatureEnabled endpoint
    // (_EnterpriseOpsService.isFeatureEnabled), already used elsewhere for feature-flag reads.
    getIdentityVerificationPolicy = async () => {
        try {
            const [mobileResponse, emailResponse] = await Promise.all([
                _EnterpriseOpsService.isFeatureEnabled('MobileOtpVerification'),
                _EnterpriseOpsService.isFeatureEnabled('EmailOtpVerification')
            ]);
            this.setState({
                mobileOtpVerificationEnabled: !!(mobileResponse && mobileResponse.data && mobileResponse.data.enabled),
                emailOtpVerificationEnabled: !!(emailResponse && emailResponse.data && emailResponse.data.enabled)
            });
        } catch (e) {
            console.log('Error fetching identity verification policy: ', e);
        }
    }

    registrationDisable = async (ev) => {
        this.setState({ isLoading: true });
        try {
            this.props.history.push(routes.home.basePath)
        } catch (e) {
            this.props.history.push(routes.home.basePath)
            this.setState({ isLoading: false })
        }
    }

    getIpAddress = async (ev) => {

        this.setState({ isLoading: true });
        try {
            const response = await _authService.getClientIP();
            if (response) {
                this.getAllPosts();
                // this.getConfigurations();
                this.getCaptcha();
            }
            else {
                this.props.history.push(routes.home.basePath)
            }
        } catch (e) {
            this.setState({ isLoading: false })
        }
    }


    getConfigurationWithoutImage = () => {
        try {
            // Sprint 2.6.2 (Candidate Experience Modernization): was tracked as `loading`, a state key never
            // read in render() — this call produced no visual feedback at all. Consolidated onto `isLoading`,
            // the one key the shared <LoadingSpinner/> actually renders (see render(), near the page footer).
            this.setState({ isLoading: true }, async () => {
                try {
                    let temp = await _AdminService.GetPortalConfigurationWithoutImage();

                    this.setState({
                        ...this.state,
                        // Product direction change: Aadhaar/SurePass identity verification is intentionally
                        // disabled in the active registration workflow (Mobile OTP + Email OTP are the current
                        // identity-verification methods; Aadhaar/SurePass is deferred as a future optional
                        // enhancement). All Aadhaar/SurePass code, backend controllers/services, and DB objects
                        // remain intact and untouched — this single override is the only change needed to bypass
                        // it here. To re-enable, remove the override below and use temp.data as-is again.
                        config: { ...temp.data, is_Aadhar_Authentication: false },
                        isLoading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ isLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getCaptcha = () => {
        try {
            // Sprint 2.6.2: same `loading` → `isLoading` consolidation as getConfigurationWithoutImage above.
            this.setState({ isLoading: true }, async () => {
                try {
                    const response = await _AdminService.GetCaptcha();
                    if (response.status == 200 && response.data) {
                        this.setState({ isLoading: false, captcha: response.data.Obj, captchaText: '' })
                    }
                    else {
                        this.setState({ isLoading: false });
                        _notification.showMessage('error', response.data.Message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ isLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    //API operations
    getAllPosts = () => {
        try {
            this.setState({ isLoading: true }, async () => {
                try {
                    let postList = await _StudentService.GetPost();

                    this.setState({
                        ...this.state,
                        postList: postList.data,
                        isLoading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ isLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllCategories = () => {
        try {
            if (!this.state.Applied_PostId)
                return;

            // Sprint 2.6.2: same `loading` → `isLoading` consolidation as getConfigurationWithoutImage above.
            this.setState({ isLoading: true }, async () => {
                try {
                    let categoryList = await _StudentService.getAllCategory(this.state.Applied_PostId);

                    let feeAmount = 0;
                    if (!this.state.showCategory) {
                        const fee = categoryList.data.filter(x => x.Name == 'N/A');
                        feeAmount = fee ? (fee.length > 0 ? fee[0].Fees : 0) : 0;
                    }

                    this.setState({
                        ...this.state,
                        categoryList: categoryList.data,
                        isLoading: false,
                        examFee: feeAmount,
                        categoryId: 0
                    });

                } catch (e) {
                    // TODO
                    this.setState({ isLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    GetAadharLogData = async () => {

        const { Aadhaar_NumberConfirm, Applied_PostId } = this.state;

        if (!Aadhaar_NumberConfirm) {
            this.setState({ Aadhaar_NumberConfirmError: tr('registration.aadhaarRequiredEmptyError') });
            return;
        }

        // const body = {
        //     Post_Id: Applied_PostId,
        //     AadharNumber: Aadhaar_NumberConfirm.trim(),
        // };

        try {
            const response = await _AdminService.GetAadharLogDataCountByPostAndAadharNumber(Applied_PostId, Aadhaar_NumberConfirm.trim());

            return response.data; // returning the log count

        } catch (error) {
            console.error("Error fetching Aadhaar log count:", error);
            _notification.showMessage("error", "Failed to get Aadhaar log data.");
            return null;
        }
    };


    handleGenrateOtp = async (event) => {
        event.preventDefault();

        const logCount = await this.GetAadharLogData();

        if (logCount >= OTP_GENERATION_LIMIT) {

            _notification.showMessage("error", OTP_LIMIT_ERROR_MSG);
        }
        else {

            const { Aadhaar_Number, Aadhaar_NumberConfirm } = this.state;

            // Basic validation
            let hasError = false;

            if (!Aadhaar_Number || Aadhaar_Number.trim() === '') {
                this.setState({ Aadhaar_NumberError: tr('registration.aadhaarRequiredError') });
                hasError = true;
            } else if (Aadhaar_Number.length !== 12) {
                this.setState({ Aadhaar_NumberError: tr('registration.enterValidAadhaarError') });
                hasError = true;
            } else {
                this.setState({ Aadhaar_NumberError: '' });
            }

            if (!Aadhaar_NumberConfirm || Aadhaar_NumberConfirm.trim() === '') {
                this.setState({ Aadhaar_NumberConfirmError: tr('registration.confirmAadhaarRequiredError') });
                hasError = true;
            } else if (Aadhaar_NumberConfirm.length !== 12) {
                this.setState({ Aadhaar_NumberConfirmError: tr('registration.enterValidConfirmAadhaarError') });
                hasError = true;
            } else {
                this.setState({ Aadhaar_NumberConfirmError: '' });
            }

            // Check if both match
            if (
                Aadhaar_Number &&
                Aadhaar_NumberConfirm &&
                Aadhaar_Number.trim() !== Aadhaar_NumberConfirm.trim()
            ) {
                this.setState({ Aadhaar_NumberConfirmError: tr('registration.aadhaarMismatchError') });
                return;
            }

            if (hasError) return;

            this.setState({ isLoading: true });

            const body = {
                id_number: Aadhaar_NumberConfirm.trim()
            };

            try {

                const response = await _authService.GenerateAadhaarOTP(body, token);

                if (response.data.success === true && response.data.status_code === 200) {
                    const clientId = response.data.data.client_id;

                    const SentOtpMessage = "OTP sent to your Aadhaar-linked mobile number";
                    _notification.showMessage("success", SentOtpMessage);

                    this.setState({
                        client_id: clientId,
                        StatusCode: response.data.status_code,
                        MessageCode: response.data.message_code,
                        Sucess: response.data.success,
                        isLoading: false,
                    }, () => {
                        this.AddOrUpdateStudentAadharLog(); // Call the logging function
                    });

                    this.startOtpTimer(); // Start 10-min OTP cooldown

                } else if ((response.data.success === false || response.success === false) && (response.data.status_code === 422 || response.data.status_code === 429 || response.status_code === 429)) {
                    const errorMsg = response.data.message || response.message;
                    _notification.showMessage("error", errorMsg);

                    this.setState({
                        // OTP_NumberError: errorMsg,
                        isLoading: false,
                    });
                } else if ((response.success === false || response.data.success === false) && (response.data.status_code === 429 || response.status_code === 429)) {
                    const errorMsg = response.message || response.data.message;
                    _notification.showMessage("error", errorMsg);
                    this.setState({
                        // OTP_NumberError: errorMsg,
                        isLoading: false,
                    });
                }
                else {
                    const errorMsg = response.data.message;
                    _notification.showMessage("error", errorMsg);
                    this.setState({
                        // OTP_NumberError: errorMsg,
                        isLoading: false
                    });
                }

            } catch (error) {
                console.error("Error sending OTP:", error);

                const errorMsg = "Error sending OTP";
                _notification.showMessage("error", errorMsg);
                this.setState({ isLoading: false });
            }
        }
    };

    startOtpTimer = () => {
        const timeoutInSeconds = otpResendTimeout * 60;

        this.setState({ otpButtonDisabled: true, remainingTime: timeoutInSeconds });

        this.timerInterval = setInterval(() => {
            this.setState(prevState => {
                if (prevState.remainingTime <= 1) {
                    clearInterval(this.timerInterval);
                    return {
                        otpButtonDisabled: false,
                        remainingTime: 0
                    };
                }
                return { remainingTime: prevState.remainingTime - 1 };
            });
        }, 1000);
    };


    AddOrUpdateStudentAadharLog = async () => {
        try {
            const {
                Aadhaar_NumberConfirm,
                client_id,
                Applied_PostId,
                StatusCode,
                Sucess,
                MessageCode
            } = this.state;

            if (!Aadhaar_NumberConfirm) {
                this.setState({ Aadhaar_NumberConfirmError: tr('registration.aadhaarRequiredEmptyError') });
                return;
            }

            const body = {
                Id: 0,
                Client_Id: client_id,
                AadharNumber: Aadhaar_NumberConfirm.trim(),
                Post_Id: Applied_PostId,
                CreatedDate: null,
                Status: "Status value",
                StatusCode: StatusCode,
                MessageCode: MessageCode,
                Sucess: Sucess
            };

            const response = await _AdminService.AddOrUpdateStudentAadharLog(body);

            if (response.data?.IsSuccess) {

                //_notification.showMessage("success", response.data.Message || "Student Aadhaar log added successfully");
            } else {

                // _notification.showMessage("error", response.data.Message || "Failed to add/update Aadhaar log");
            }

        } catch (error) {
            console.error("Error in AddOrUpdateStudentAadharLog:", error);
            _notification.showMessage("error", "API request failed while updating Aadhaar log.");
        }
    };



    handleOtpSubmit = async () => {

        const { client_id, OTP_Number } = this.state;


        if (!OTP_Number) {
            this.setState({ OTP_NumberError: tr('registration.otpRequiredEmptyError') });
            return;
        } else {
            this.setState({ OTP_NumberError: '' });
        }

        if (!client_id) {
            this.setState({ OTP_NumberError: tr('registration.provideValidAadharOtpError') });
            return;
        } else {
            this.setState({ OTP_NumberError: '' });
        }

        this.setState({ isLoading: true });

        const body = {
            client_id: client_id,
            otp: OTP_Number.trim()
        };

        let response = null;


        try {
            // You should define or import 'token' properly here
            response = await _authService.SubmitAadhaarOTP(body, token);

            if (response && response.data.success === true && response.data.status_code === 200) {

                const msg = "OTP has been verified successfully.";
                _notification.showMessage("success", msg);


                this.setState({
                    //OTP_NumberSucess: msg,
                    aadharOtpVerity: response.data.success,
                    isLoading: false,
                });
            } else if ((response.data.success === false || response.success === false) && (response.data.status_code === 422 || response.data.status_code === 500 || response.status_code === 500)) {
                let errorMsg = response.message || response.data.message;

                if (errorMsg.toLowerCase() === "verification failed.") {
                    errorMsg = "Verification failed.Please enter a valid OTP number.";
                    _notification.showMessage("error", errorMsg);
                }

               _notification.showMessage("error", errorMsg);

                this.setState({
                    // OTP_NumberError: errorMsg,
                    isLoading: false,
                });
            } else if ((response.success === false || response.data.success === false) && (response.status_code === 500 || response.data.status_code === 500)) {
                const errorMsg = response.message || response.data.message;
                _notification.showMessage("error", errorMsg);

                this.setState({
                    // OTP_NumberError: errorMsg,
                    isLoading: false,
                });

            } else if ((response.data === null || response.data.data === null || response.success === null)) {
                const errorMsg = "Please provide valid Aadhar Number/Otp Number.";
                _notification.showMessage("error", errorMsg);

                this.setState({
                    // OTP_NumberError: errorMsg,
                    isLoading: false,
                });
            }
            else {
                const errorMsg = response.data.message;
                _notification.showMessage("error", errorMsg);

                this.setState({
                    //  OTP_NumberError: errorMsg,
                    isLoading: false,
                });
            }

        } catch (error) {

            console.error("Error submitting OTP:", error);

            const errorMsg = "OTP verification failed.Please enter a valid OTP number.";
            //const errorMsg = error.response.data.message;
            _notification.showMessage("error", errorMsg);

            this.setState({
                isLoading: false,
                //OTP_NumberSucess: errorMsg,
            });

        }
    };

    onExamChange = (event) => {
        const exam = this.state.postList.filter(x => x.Id == event.target.value);

        this.setState({
            ...this.state,
            Applied_PostId: event.target.value,
            showCategory: exam ? (exam.length > 0 ? exam[0].IsCategoryMandatory : false) : false,
            showAadharMandatory: exam ? (exam.length > 0 ? exam[0].IsAadharMandetory : false) : false,
            showKaryalayinKamgar: exam ? (exam.length > 0 ? exam[0].IsKaryalayinKaamkaj : false) : false,
            showExServiceManCheckBox: exam ? (exam.length > 0 ? exam[0].ShowExServiceMan : false) : false,
            showHandicapCheckBox: exam ? (exam.length > 0 ? exam[0].ShowHandicap : false) : false,
            showMahilaReservationCheckBox: exam ? (exam.length > 0 ? exam[0].ShowMahila : false) : false,
            ShowShowEarthquakeCheckBox: exam ? (exam.length > 0 ? exam[0].ShowEarthquake : false) : false,
            ShowProjectAffectedCheckBox: exam ? (exam.length > 0 ? exam[0].ShowPrakalpGrast : false) : false,
            ShowPlayerCheckBox: exam ? (exam.length > 0 ? exam[0].ShowPlayer : false) : false,
            ShowAnshkalinCheckBox: exam ? (exam.length > 0 ? exam[0].ShowAnshkalin : false) : false,
            ShowOrphanCheckBox: exam ? (exam.length > 0 ? exam[0].ShowOrphan : false) : false,
            // showMahilaReservationCheckBox: true,
            // ShowShowEarthquakeCheckBox: true,
            // ShowProjectAffectedCheckBox: true,
            // ShowPlayerCheckBox: true,
            // ShowAnshkalinCheckBox: true,
            // ShowOrphanCheckBox: true,
            Ex_Serviceman: false,
            Is_Ladies: false,
            Earth_Quake_Affected: false,
            Is_Praklapgast: false,
            Is_Player: false,
            Is_Anshkalin: false,
            Is_Orphan: false,
            Is_Handicaped: false,
            IsScribeRequired: false,
            karyalayinKamkaj: false
        }, async () => {
            this.getAllCategories();
        });
    }

    onCategoryChange = (event) => {

        const fee = this.state.categoryList.filter(x => x.Id == event.target.value);

        this.setState({
            ...this.state,
            categoryId: event.target.value,
            examFee: fee ? (fee.length > 0 ? fee[0].Fees : 0) : 0,
            Ex_Serviceman: false,
            Is_Handicaped: false,
            Is_Ladies: false,
            Earth_Quake_Affected: false,
            Is_Praklapgast: false,
            Is_Player: false,
            Is_Anshkalin: false,
            Is_Orphan: false,

            // IsScribeRequired: false,
        });
    }

    onChangeKaryalayinKamkaj = e => {
        this.setState({
            ...this.state,
            karyalayinKamkaj: !this.state.karyalayinKamkaj,
        });
    };

    onChangeCheckBox = (flag) => {
        if (flag && flag === "Ex_Serviceman") {
            this.setState({
                Ex_Serviceman: !this.state.Ex_Serviceman,
            })
        }
        else if (flag && flag === "Is_Ladies") {
            this.setState({
                Is_Ladies: !this.state.Is_Ladies,
            })
        }
        else if (flag && flag === "Earth_Quake_Affected") {
            this.setState({
                Earth_Quake_Affected: !this.state.Earth_Quake_Affected,
            })
        }
        else if (flag && flag === "Is_Praklapgast") {
            this.setState({
                Is_Praklapgast: !this.state.Is_Praklapgast,
            })
        }
        else if (flag && flag === "Is_Player") {
            this.setState({
                Is_Player: !this.state.Is_Player,
            })
        }
        else if (flag && flag === "Is_Anshkalin") {
            this.setState({
                Is_Anshkalin: !this.state.Is_Anshkalin,
            })
        }
        else if (flag && flag === "Is_Orphan") {
            this.setState({
                Is_Orphan: !this.state.Is_Orphan,
            })
        }
        else if (flag && flag === "IsScribeRequired") {
            this.setState({
                IsScribeRequired: !this.state.IsScribeRequired
            })
        }
        else if (flag && flag === "is_DateConfirm") {
            this.setState({
                is_DateConfirm: !this.state.is_DateConfirm,
            })
        }
        else if (flag && flag === "is_ConsentAccepted") {
            this.setState({
                is_ConsentAccepted: !this.state.is_ConsentAccepted,
                is_ConsentAcceptedError: ''
            })
        }
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'phoneNumber' && !_validator.isDigit(value))
            return;

        if (name == 'Aadhaar_Number' && !_validator.isDigit(value))
            return;

        if (name == 'Aadhaar_NumberConfirm' && !_validator.isDigit(value))
            return;

        if (name == 'phoneNumber' && value.length > 10)
            return;

        if (name == 'captchaText' && value.length > 6)
            return;

        if ((name == 'firstName'
            || name == 'lastName') && !_validator.onlyAlphabets(value))
            return;

        if ((name == 'firstName'
            || name == 'lastName') && value.length > 25)
            return;

        if ((name == 'passwordConfirm'
            || name == 'password') && value.length > 25)
            return;

        if (name == 'email' && value.length > 50)
            return;

        if (name == 'Aadhaar_Number' && value.length > 12)
            return;

        if (name == 'Aadhaar_NumberConfirm' && value.length > 12)
            return;

        if ((name == 'Aadhaar_Number'
            || name == 'Aadhaar_NumberConfirm') && value.length > 12)
            return;

        if (name == 'OTP_Number' && !_validator.isDigit(value))
            return;

        if (name == 'OTP_Number' && value.length > 6)
            return;

        this.setState({
            ...this.state,
            [name]: value
        });
    }

    onDateChange = (date) => {
        let Birth_DateError = "";

        var todayDate = moment.utc();
        var futureDate = moment.utc(date, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"]);

        // Check if the date is invalid
        if (!futureDate.isValid()) {
            Birth_DateError = tr('registration.enterAValidBirthDateError');
        }
        // Check if the entered date is in the future
        else if (futureDate.isAfter(todayDate)) {
            Birth_DateError = tr('registration.futureDatesNotAllowedError');
        }

        // Update state with the error message and the selected date
        this.setState({
            ...this.state,
            Birth_Date: date ? date : "",
            Birth_DateError: Birth_DateError
        });
    };

    onRefresh = async (ev) => {
        this.getCaptcha();
    }

    // Sprint 2.6.2 (Candidate Experience Modernization): validateFormData() only sets inline field-error
    // state — it never scrolled the page, so a candidate scrolled past the form (e.g. down at the Submit
    // button) had no way to notice new red text appearing above. This brings the form back into view on
    // any validation failure so the inline errors are actually seen.
    scrollToFormTop = () => {
        const formNode = document.querySelector('.registrationForm');
        if (formNode && formNode.scrollIntoView) {
            formNode.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    handleRegistration = async (ev) => {
        ev.preventDefault();

        if (this.state.is_DateConfirm === false) {
            this.setState({
                is_DateConfirmError: tr('registration.confirmDobCheckboxError')
            })
            this.scrollToFormTop();
            return
        }
        // Registration-blocker fix: server-side (StudentService.Register) already rejects a submission
        // missing a valid Identity_Verification_Token whenever Mobile/Email OTP verification is enabled
        // (business-logic re-validation, unchanged by this fix) — this client-side check only makes the
        // existing requirement visible before the round-trip, matching every other gate in this function.
        if ((this.state.mobileOtpVerificationEnabled || this.state.emailOtpVerificationEnabled) && !this.state.identityVerificationToken) {
            this.setState({
                identityVerificationError: tr('registration.identityVerificationRequiredError')
            })
            this.scrollToFormTop();
            return
        }
        // Sprint 2.2 (Privacy & Consent Foundation): candidate must accept the Privacy Policy / Terms &
        // Conditions before registration can be submitted.
        if (this.state.is_ConsentAccepted === false) {
            this.setState({
                is_ConsentAcceptedError: tr('registration.consentRequiredError')
            })
            this.scrollToFormTop();
            return
        }
        if (this.validateFormData()) {
            this.scrollToFormTop();
            return
        }

        this.setState({
            isLoading: true
        }, async () => {
            try {

                const exam = this.state.postList.filter(x => x.Id == this.state.Applied_PostId);
                let Applied_Post = exam[0].Name;

                let body = {};
                body.First_Name = this.state.firstName.trim();
                body.Last_Name = this.state.lastName.trim();
                body.Mobile_Number = this.state.phoneNumber;
                body.email = this.state.email.trim();
                body.Password = this.state.password;
                body.Applied_PostId = this.state.Applied_PostId;
                body.Birth_Date = this.state.Birth_Date;
                body.Aadhaar_Number = this.state.Aadhaar_Number;
                body.CaptchaText = this.state.captchaText;
                body.GUID = this.state.captcha.GUID;
                body.Is_KaryalayinKamkaj = this.state.karyalayinKamkaj;
                body.Category_Id = this.state.categoryId;
                body.Ex_Serviceman = this.state.showExServiceManCheckBox ? this.state.Ex_Serviceman : false;
                body.Is_Ladies = this.state.showMahilaReservationCheckBox ? this.state.Is_Ladies : false;
                body.Is_Handicaped = this.state.showHandicapCheckBox ? this.state.Is_Handicaped : false;
                body.IsScribeRequired = this.state.Is_Handicaped ? this.state.IsScribeRequired : false;
                body.Applied_Post = Applied_Post ? Applied_Post : "";
                body.Earth_Quake_Affected = this.state.ShowShowEarthquakeCheckBox ? this.state.Earth_Quake_Affected : false;
                body.Is_Praklapgast = this.state.ShowProjectAffectedCheckBox ? this.state.Is_Praklapgast : false;
                body.Is_Player = this.state.ShowPlayerCheckBox ? this.state.Is_Player : false;
                body.Is_Anshkalin = this.state.ShowAnshkalinCheckBox ? this.state.Is_Anshkalin : false;
                body.Is_Orphan = this.state.ShowOrphanCheckBox ? this.state.Is_Orphan : false;
                body.Identity_Verification_Token = this.state.identityVerificationToken;

                const response = await _authService.register(body);
                if (response.data.ApplicationId) {
                    // Sprint 2.2 (Privacy & Consent Foundation): record consent against the just-assigned
                    // Application_Id. Best-effort — a consent-logging failure must not block a completed
                    // registration from reaching its success page.
                    try {
                        await _authService.submitConsent({
                            Application_Id: response.data.ApplicationId,
                            ConsentType: 'PrivacyPolicyAndTerms'
                        });
                    } catch (consentError) {
                        console.log('Consent logging error: ', consentError);
                    }

                    this.setState({
                        isLoading: false
                    }, () => {
                        _notification.showMessage('success', 'Registration completed successfully. Please login to access your profile.');
                        this.props.history.push({ pathname: routes.registrationComplete.basePath, state: { applicationID: response.data.ApplicationId } })
                    })
                }
                else {
                    this.setState({
                        isLoading: false
                    }, () => {
                        ev.preventDefault();
                        _notification.showMessage('error', response.data.ListOfCompulsouryFields.join(' '), 5);
                    })
                }
            } catch (e) {
                // TODO
                console.log('Error: ', e);
            }
        });

    }

    validateFormData = () => {
        let body = this.state;

        this.setState({
            Exam_ErrorError: '',
            firstNameError: '',
            lastNameError: '',
            emailError: '',
            phoneNumberError: '',
            passwordError: '',
            passwordConfirmError: '',
            Birth_DateError: '',
            categoryIdError: '',
            is_DateConfirmError: '',
            identityVerificationError: '',
            Aadhaar_NumberError: '',
            Aadhaar_NumberConfirmError: '',

        });

        let hasError = false;

        if (!body.Applied_PostId) {
            this.setState({ Exam_ErrorError: tr('registration.selectPostExamError') });
            hasError = true
        }

        if (!body.captchaText) {
            this.setState({ captchaTextError: tr('registration.pleaseEnterCaptchaError') });
            hasError = true
        }

        if (!body.firstName || !body.firstName.trim()) {
            this.setState({ firstNameError: tr('registration.enterValidFirstNameError') });
            hasError = true
        }

        if (!body.lastName || !body.lastName.trim()) {
            this.setState({ lastNameError: tr('registration.enterValidLastNameError') });
            hasError = true
        }

        if (!body.email || !body.email.trim()) {
            this.setState({ emailError: tr('registration.enterValidEmailError') });
            hasError = true
        }

        if (!_validator.verifyEmail(body.email)) {
            this.setState({ emailError: tr('registration.enterValidEmailError') });
            hasError = true
        }

        if (!body.Birth_Date) {
            this.setState({ Birth_DateError: tr('registration.enterValidBirthDateError') });
            hasError = true
        }

        if (moment(body.Birth_Date).isValid() && moment(body.Birth_Date).isSameOrAfter(moment(), 'day')) {
            this.setState({ Birth_DateError: tr('registration.enterValidBirthDateError') });
            hasError = true
        }

        if (body.Birth_Date === "Invalid date") {
            this.setState({ Birth_DateError: tr('registration.enterValidBirthDateError') });
            hasError = true
        }

        var todayDate = moment();
        var futureDate = moment(body.Birth_Date);

        if (futureDate.isAfter(todayDate)) {
            this.setState({ Birth_DateError: tr('registration.futureDatesNotAllowedError') });
            hasError = true
        }

        if (!body.phoneNumber) {
            this.setState({ phoneNumberError: tr('registration.enterValidMobileError') });
            hasError = true
        }

        if (body.phoneNumber.length != 10) {
            this.setState({ phoneNumberError: tr('registration.enterValidMobileError') });
            hasError = true
        }

        if (this.state.showCategory && !this.state.categoryId) {
            this.setState({ categoryIdError: tr('registration.selectValidCategoryError') });
            hasError = true
        }

        if (this.state.showAadharMandatory) {
            if (body.Aadhaar_Number.length != 12) {
                this.setState({ Aadhaar_NumberError: tr('registration.enterValidAadhaarError') });
                hasError = true
            }
        }

        if (this.state.showAadharMandatory) {
            if (body.Aadhaar_NumberConfirm.length != 12) {
                this.setState({ Aadhaar_NumberConfirmError: tr('registration.enterValidConfirmAadhaarError') });
                hasError = true
            }
        }

        if (!body.password) {
            this.setState({ passwordError: tr('registration.enterValidPasswordError') });
            hasError = true
        }

        if (!body.passwordConfirm) {
            this.setState({ passwordConfirmError: tr('registration.enterValidConfirmPasswordError') });
            hasError = true
        }

        if (body.password != body.passwordConfirm) {
            // Sprint 2.6.2: dropped the duplicate toast — the inline errors below already surface this
            // right next to the two fields, matching how every other field error in this form is signaled.
            this.setState({
                passwordConfirmError: tr('registration.passwordMismatchError'),
                passwordError: tr('registration.passwordMismatchError')
            });
            hasError = true
        }

        if (body.Aadhaar_Number != body.Aadhaar_NumberConfirm) {
            this.setState({
                Aadhaar_NumberError: tr('registration.aadhaarMismatchError'),
                Aadhaar_NumberConfirmError: tr('registration.aadhaarMismatchError')
            });
            hasError = true
        }

        return hasError;
    }

    preventCopyPaste = (e) => {
        e.preventDefault()
    }

    handleOpenModal = () => {
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };

    handleSubmitModal = (e) => {
        this.setState({ showModal: false });
        this.handleRegistration(e)
    }

    render() {

        return (<>
            <div
                className="d-flex align-items-center justify-content-center flex-column registrationForm">
                {/* Stage 3.9 (Task 1): m-5 (48px) → m-4 (24px) — outer-wrapper density trim; p-4/h-100/
                    ent-container unchanged. */}
                <div className="form-wrapper p-4 m-4 h-100 ent-container">

                    {/* Stage 3.4 (Enterprise Registration Page Modernization): the form is now organized
                        into 7 Enterprise Cards, each with a real <h2> (via Card's `header` prop) instead
                        of the previous plain-div .form-section-title. Category+Fee and Date of Birth are
                        relocated (disclosed, user-confirmed minimal reordering — see
                        frontendDesign/Stage_3_4/Reports/ERPM_S3_4_ChangeLog.md) to sit with their correct
                        section instead of sharing a row with an unrelated field for column balance. Every
                        field below keeps its exact original name/value/onChange/errorState prop. */}

                    {/* Post Information */}
                    {/* Phase C.7.4 (§"Section Styling"/"Form Information Architecture"): re-visible —
                        Stage 3.9's sr-only treatment left the first 4 sections with no on-screen title
                        at all, while the later 3 (Account Security/Reservation/Review & Submit) kept a
                        visible <h2>, an inconsistent hierarchy live-confirmed to read as one continuous
                        undivided surface rather than distinct sections. Restoring the visible heading
                        (same text/i18n key, same Card/`.ent-card-header` treatment already used by the
                        other 3) fixes that inconsistency with no new component and no logic change. */}
                    <Card header={<h2 className="displayInGrid"><Text k="registration.postInformationHeading" /></h2>}>
                        <div className="row w-100  m-0">
                            <div className="col-12">
                                <DropdownList
                                    value={this.state.Applied_PostId ? this.state.Applied_PostId : 0}
                                    name="Applied_PostId"
                                    onChange={this.onExamChange}
                                    placeholder={tr('registration.selectPostPlaceholder')}
                                    heading={<div className='displayInGrid'><Text k="registration.examPostLabel" /></div>}
                                    className="w-100"
                                    wrapClass="wrap"
                                    isRequired={true}
                                    options={this.state.postList}
                                    errorState={this.state.Exam_ErrorError}
                                    errorMessage={this.state.Exam_ErrorError}

                                />
                            </div>
                        </div>
                        <div className="row w-100  m-0">
                            {this.state.showCategory && <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <DropdownList
                                    value={this.state.categoryId ? this.state.categoryId : 0}
                                    name="Category_Id"
                                    onChange={this.onCategoryChange}
                                    placeholder={tr('registration.selectCategoryPlaceholder')}
                                    heading={<div className='displayInGrid'><Text k="registration.categoryLabel" /></div>}
                                    className="w-100"
                                    wrapClass="wrap"
                                    isRequired={true}
                                    options={this.state.categoryList}
                                    errorState={this.state.categoryIdError}
                                    errorMessage={this.state.categoryIdError}
                                />
                            </div>}
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <MyInput
                                    wrapClass="mt-2"
                                    key="examFee"
                                    type="text"
                                    value={this.state.examFee}
                                    name="examFee"
                                    onChange={this.onTextChange}
                                    placeholder={tr('registration.examFeeLabel')}
                                    heading={<div className='displayInGrid'><Text k="registration.examFeeLabel" /></div>}
                                    //isRequired={true}
                                    disabled={true}
                                // errorState={this.state.phoneNumberError}
                                // errorMessage={this.state.phoneNumberError}
                                />
                            </div>
                        </div>
                    </Card>

                    {/* Personal Information */}
                    {/* Phase C.7.4: re-visible — see Post Information above for rationale. */}
                    <Card header={<h2 className="displayInGrid"><Text k="registration.personalInformationHeading" /></h2>}>
                        <div className="row w-100  m-0">
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <MyInput
                                    wrapClass="mt-2"
                                    key="firstName"
                                    type="text"
                                    value={this.state.firstName}
                                    name="firstName"
                                    onChange={this.onTextChange}
                                    placeholder={tr('registration.enterFirstNamePlaceholder')}
                                    heading={<div className='displayInGrid'><Text k="registration.firstNameLabel" /></div>}
                                    isRequired={true}
                                    errorState={this.state.firstNameError}
                                    errorMessage={this.state.firstNameError}

                                />
                            </div>
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <MyInput
                                    wrapClass="mt-2"
                                    key="lastName"
                                    type="text"
                                    value={this.state.lastName}
                                    name="lastName"
                                    onChange={this.onTextChange}
                                    placeholder={tr('registration.enterLastNamePlaceholder')}
                                    heading={<div className='displayInGrid'><Text k="registration.lastNameLabel" /></div>}
                                    isRequired={true}
                                    errorState={this.state.lastNameError}
                                    errorMessage={this.state.lastNameError}

                                />
                            </div>
                        </div>
                        <div className="row w-100  m-0">
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <div>
                                    {/* Phase C.7.4D-R1 (§4): ent-required-asterisk — this hand-built label (outside
                                        MyInput/DropdownList) had the same zero-gap asterisk issue. */}
                                    <label>
                                        <div className="displayInGrid">
                                            <Text k="registration.dateOfBirthLabel" />
                                        </div>
                                        <span className="color-red ent-required-asterisk">*</span>
                                    </label>
                                    {/* <DatePicker className={this.state.Birth_DateError ? "has-error mt7" : 'mt7'} onChange={this.onDateChange} format="DD-MMM-YYYY" defaultValue={moment(this.state.Birth_Date).isValid() ? moment(this.state.Birth_Date) : null} placeholder='Select Birth Date (जन्मतारीख निवडा)' /> */}
                                    <DatePicker className={this.state.Birth_DateError ? "has-error datePickerClass" : 'datePickerClass'} onChange={this.onDateChange} />
                                    {this.state.Birth_DateError && <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.Birth_DateError}</label>}
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Contact Information */}
                    {/* Phase C.7.4: re-visible — see Post Information above for rationale. */}
                    <Card header={<h2 className="displayInGrid"><Text k="registration.contactInformationHeading" /></h2>}>
                        <div className="row w-100  m-0">
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <div className="form-group">
                                    <MyInput
                                        wrapClass="mt-2"
                                        key="phoneNumber"
                                        type="text"
                                        value={this.state.phoneNumber}
                                        name="phoneNumber"
                                        onChange={this.onTextChange}
                                        placeholder={tr('registration.enterMobilePlaceholder')}
                                        heading={<div className='displayInGrid'><Text k="registration.mobileNumberLabel" /></div>}
                                        isRequired={true}
                                        errorState={this.state.phoneNumberError}
                                        errorMessage={this.state.phoneNumberError}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <div className="form-group">
                                    {/* Phase C.7.4A (§7 Contact Information alignment): the root cause
                                        of the Mobile/Email vertical misalignment, live-confirmed —
                                        Mobile Number's MyInput carries `wrapClass="mt-2"` (matching
                                        every other 2-column row in this form, e.g. First/Last Name)
                                        but this one didn't, giving it ~8px less top margin than its
                                        row partner. Field name/state/validation unchanged. */}
                                    <MyInput
                                        wrapClass="mt-2"
                                        key="email"
                                        type="text"
                                        value={this.state.email}
                                        name="email"
                                        onChange={this.onTextChange}
                                        placeholder={tr('registration.enterEmailPlaceholder')}
                                        heading={<div className='displayInGrid'><Text k="registration.emailLabel" /></div>}
                                        isRequired={true}
                                        errorState={this.state.emailError}
                                        errorMessage={this.state.emailError}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Identity Information — consolidates all 3 existing identity paths (optional
                        Aadhaar / mandatory Aadhaar+OTP / Mobile+Email OTP) under one heading; each path
                        keeps its own original gating condition, unchanged. */}
                    {/* Phase C.7.4: re-visible — see Post Information above for rationale. */}
                    <Card header={<h2 className="displayInGrid"><Text k="registration.identityInformationHeading" /></h2>}>
                        {this.state.config.is_Aadhar_Authentication == false && (
                            <>
                                <div className="row w-100  m-0">
                                    <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <MyInput
                                                wrapClass="mt-2"
                                                key="Aadhaar_Number"
                                                type="text"
                                                onCopy={(e) => this.preventCopyPaste(e)}
                                                onPaste={(e) => this.preventCopyPaste(e)}
                                                onCut={(e) => this.preventCopyPaste(e)}
                                                value={this.state.Aadhaar_Number}
                                                name="Aadhaar_Number"
                                                onChange={this.onTextChange}
                                                placeholder={tr('registration.enterAadhaarPlaceholder')}
                                                heading={this.state.showAadharMandatory ? <div className='displayInGrid'><Text k="registration.aadhaarNumberLabel" /></div>
                                                    : <div className='displayInGrid'><Text k="registration.aadhaarNumberOptionalLabel" /></div>
                                                }
                                                isRequired={this.state.showAadharMandatory}
                                                errorState={this.state.Aadhaar_NumberError}
                                                errorMessage={this.state.Aadhaar_NumberError}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <MyInput
                                                wrapClass="mt-2"
                                                key="Aadhaar_NumberConfirm"
                                                type="password"
                                                onCopy={(e) => this.preventCopyPaste(e)}
                                                onPaste={(e) => this.preventCopyPaste(e)}
                                                onCut={(e) => this.preventCopyPaste(e)}
                                                value={this.state.Aadhaar_NumberConfirm}
                                                name="Aadhaar_NumberConfirm"
                                                onChange={this.onTextChange}
                                                placeholder={tr('registration.confirmAadhaarPlaceholder')}
                                                heading={this.state.showAadharMandatory ? <div className='displayInGrid'><Text k="registration.confirmAadhaarNumberLabel" /></div>
                                                    : <div className='displayInGrid'><Text k="registration.confirmAadhaarNumberOptionalLabel" /></div>
                                                }
                                                isRequired={this.state.showAadharMandatory}
                                                errorState={this.state.Aadhaar_NumberConfirmError}
                                                errorMessage={this.state.Aadhaar_NumberConfirmError}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {(this.state.mobileOtpVerificationEnabled || this.state.emailOtpVerificationEnabled) && (
                            <div className="row w-100 m-0">
                                <div className="col-12">
                                    <IdentityVerificationPanel
                                        postId={Number(this.state.Applied_PostId)}
                                        mobileNumber={this.state.phoneNumber}
                                        email={this.state.email}
                                        mobileEnabled={this.state.mobileOtpVerificationEnabled}
                                        emailEnabled={this.state.emailOtpVerificationEnabled}
                                        mobileLabel={<div className='displayInGrid'><Text k="registration.mobileNumberLabel" /></div>}
                                        emailLabel={<div className='displayInGrid'><Text k="registration.emailAddressLabel" /></div>}
                                        onVerified={(token) => this.setState({ identityVerificationToken: token, identityVerificationError: '' })}
                                    />
                                    {!this.state.identityVerificationToken && <label className="color-secondary-text d-block mt-1"><Text k="registration.verifyIdentityHint" /></label>}
                                    {this.state.identityVerificationError !== "" ? <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.identityVerificationError}</label> : ""}
                                </div>
                            </div>
                        )}

                        {this.state.config.is_Aadhar_Authentication == true && (
                            <>
                                <div className="row w-100 m-0 align-items-top">
                                    {/* Aadhaar Number Input */}
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <MyInput
                                                wrapClass="mt-2"
                                                key="Aadhaar_Number"
                                                type="text"
                                                onCopy={(e) => this.preventCopyPaste(e)}
                                                onPaste={(e) => this.preventCopyPaste(e)}
                                                onCut={(e) => this.preventCopyPaste(e)}
                                                value={this.state.Aadhaar_Number}
                                                name="Aadhaar_Number"
                                                onChange={this.onTextChange}
                                                placeholder={tr('registration.enterAadhaarPlaceholder')}
                                                heading={this.state.showAadharMandatory ? (
                                                    <div className='displayInGrid'>
                                                        <Text k="registration.aadhaarNumberLabel" />
                                                    </div>
                                                ) : (
                                                    <div className='displayInGrid'>
                                                        <Text k="registration.aadhaarNumberOptionalLabel" />
                                                    </div>
                                                )}
                                                isRequired={this.state.showAadharMandatory}
                                                errorState={this.state.Aadhaar_NumberError}
                                                errorMessage={this.state.Aadhaar_NumberError}
                                            />
                                        </div>
                                    </div>

                                    {/* Confirm Aadhaar Number Input */}
                                    <div className="col-xl-5 col-lg-4 col-md-6 col-sm-12">
                                        <div className="form-group ">
                                            <MyInput
                                                wrapClass="mt-2"
                                                key="Aadhaar_NumberConfirm"
                                                type="password"
                                                onCopy={(e) => this.preventCopyPaste(e)}
                                                onPaste={(e) => this.preventCopyPaste(e)}
                                                onCut={(e) => this.preventCopyPaste(e)}
                                                value={this.state.Aadhaar_NumberConfirm}
                                                name="Aadhaar_NumberConfirm"
                                                onChange={this.onTextChange}
                                                placeholder={tr('registration.confirmAadhaarPlaceholder')}
                                                heading={this.state.showAadharMandatory ? (
                                                    <div className='displayInGrid'>
                                                        <Text k="registration.confirmAadhaarNumberLabel" />
                                                    </div>
                                                ) : (
                                                    <div className='displayInGrid'>
                                                        <Text k="registration.confirmAadhaarNumberOptionalLabel" />
                                                    </div>
                                                )}
                                                isRequired={this.state.showAadharMandatory}
                                                errorState={this.state.Aadhaar_NumberConfirmError}
                                                errorMessage={this.state.Aadhaar_NumberConfirmError}
                                            />
                                        </div>
                                    </div>

                                    {/* Send OTP Button */}
                                    <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12">
                                        <div className="d-flex justify-content-center mt-8">
                                            <button
                                                onClick={this.handleGenrateOtp}

                                                disabled={
                                                    this.state.otpButtonDisabled ||
                                                    !this.state.Aadhaar_NumberConfirm ||
                                                    this.state.Aadhaar_NumberConfirm.trim() === '' ||
                                                    this.state.Aadhaar_NumberConfirm.length !== 12 ||
                                                    !this.state.Aadhaar_Number ||
                                                    this.state.Aadhaar_Number.length !== 12 ||
                                                    this.state.Aadhaar_Number.trim() === ''
                                                }
                                                style={{
                                                    cursor: this.state.otpButtonDisabled ||
                                                        !this.state.Aadhaar_NumberConfirm ||
                                                        this.state.Aadhaar_NumberConfirm.trim() === '' ||
                                                        this.state.Aadhaar_NumberConfirm.length !== 12 ||
                                                        !this.state.Aadhaar_Number ||
                                                        this.state.Aadhaar_Number.length !== 12 ||
                                                        this.state.Aadhaar_Number.trim() === ''
                                                        ? 'not-allowed'
                                                        : 'pointer'
                                                }}

                                                className="button-global button-primary autoHeight mw125 mt10"
                                            >

                                                <Text k="registration.sendOtpButton" />
                                            </button>
                                        </div>

                                        {this.state.otpButtonDisabled && (
                                            <div>
                                                <small className="text-center mts ml-3 p">
                                                    <Text k="registration.enableButtonAfterPrefix" /> {Math.floor(this.state.remainingTime / 60)}:
                                                    {(this.state.remainingTime % 60).toString().padStart(2, '0')}
                                                </small>
                                            </div>
                                        )}
                                    </div>

                                </div>

                                <div className="row w-100 m-0 align-items-top">
                                    <div className="col-xl-6 col-lg-6 d-flex ">
                                        <div className="form-group w-100">
                                            <MyInput
                                                wrapClass="mt-2"
                                                key="OTP_Number"
                                                type="password"
                                                className="custom-password-style"
                                                onCopy={(e) => this.preventCopyPaste(e)}
                                                onPaste={(e) => this.preventCopyPaste(e)}
                                                onCut={(e) => this.preventCopyPaste(e)}
                                                value={this.state.OTP_Number}
                                                name="OTP_Number"
                                                onChange={this.onTextChange}
                                                placeholder={tr('registration.enterOtpPlaceholder')}
                                                heading={
                                                    <div className='displayInGrid'><Text k="registration.otpNumberLabel" /></div>
                                                }
                                                isRequired={this.state.showAadharMandatory}
                                                errorState={this.state.OTP_NumberError}
                                                errorMessage={this.state.OTP_NumberError}
                                                successState={this.state.OTP_NumberSucess}
                                                successMessage={this.state.OTP_NumberSucess}

                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12">
                                        <div className="form-group d-flex justify-content-center mt-5">
                                            <button
                                                onClick={this.handleOtpSubmit}
                                                disabled={
                                                    !this.state.OTP_Number || this.state.OTP_Number.trim().length !== 6
                                                }
                                                style={{
                                                    cursor:
                                                        !this.state.OTP_Number || this.state.OTP_Number.trim().length !== 6
                                                            ? 'not-allowed'
                                                            : 'pointer'
                                                }}

                                                className="button-global button-primary autoHeight mw125 mt10"

                                            >
                                                <Text k="registration.submitOtpButton" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </Card>

                    {/* Account Security */}
                    <Card header={<h2 className="displayInGrid"><Text k="registration.accountSecurityHeading" /></h2>}>
                        <div className="row w-100  m-0">
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <div className="form-group">
                                    <MyInput
                                        wrapClass="mt-2"
                                        key="password"
                                        type="password"
                                        onCopy={(e) => this.preventCopyPaste(e)}
                                        onPaste={(e) => this.preventCopyPaste(e)}
                                        onCut={(e) => this.preventCopyPaste(e)}
                                        value={this.state.password}
                                        name="password"
                                        onChange={this.onTextChange}
                                        placeholder={tr('registration.enterPasswordPlaceholder')}
                                        heading={<div className='displayInGrid'><Text k="registration.passwordLabel" /></div>}
                                        isRequired={true}
                                        errorState={this.state.passwordError}
                                        errorMessage={this.state.passwordError}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                <div className="form-group">
                                    <MyInput
                                        wrapClass="mt-2"
                                        key="confirmPassword"
                                        type="password"
                                        onCopy={(e) => this.preventCopyPaste(e)}
                                        onPaste={(e) => this.preventCopyPaste(e)}
                                        onCut={(e) => this.preventCopyPaste(e)}
                                        value={this.state.passwordConfirm}
                                        name="passwordConfirm"
                                        onChange={this.onTextChange}
                                        placeholder={tr('registration.enterConfirmPasswordPlaceholder')}
                                        heading={<div className='displayInGrid'><Text k="registration.confirmPasswordLabel" /></div>}
                                        isRequired={true}
                                        errorState={this.state.passwordConfirmError}
                                        errorMessage={this.state.passwordConfirmError}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Reservation Details — Phase C.7.4: the whole Card is now conditional on there
                        being at least one checkbox to actually show. Before selecting a post (or for a
                        post with neither reservation flag), this section previously still rendered a
                        full-width Card containing only a header and an empty row — a visibly oversized
                        empty container (live-confirmed, matching this phase's own "excessive white
                        space"/"oversized containers" findings). No field/handler/state changed — only
                        whether this wrapper renders at all. */}
                    {Boolean(this.state.showExServiceManCheckBox || (this.state.Applied_PostId && this.state.Applied_PostId !== 0)) &&
                    <Card header={<h2 className="displayInGrid"><Text k="registration.reservationDetailsHeading" /></h2>}>
                        <div className="row w-100 m-0">
                            {(this.state.showExServiceManCheckBox) &&
                                <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                    <InputCheck
                                        id="Ex_Serviceman"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="registration.exServicemanLabel" /></div>}
                                        name="Ex_Serviceman"
                                        onChange={() => this.onChangeCheckBox("Ex_Serviceman")}
                                        checked={this.state.Ex_Serviceman ? this.state.Ex_Serviceman : false}
                                    />
                                </div>
                            }
                            {this.state.Applied_PostId && this.state.Applied_PostId !== 0 ?

                                <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                                    <InputCheck
                                        id="Is_KaryalayinKamkaj"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="registration.karyalayinKamgarLabel" /></div>}
                                        wrapclassName="mr-3 mb-2"
                                        name="Is_KaryalayinKamkaj"
                                        value="false"
                                        onChange={this.onChangeKaryalayinKamkaj}
                                        checked={this.state.karyalayinKamkaj ? this.state.karyalayinKamkaj : false}
                                    />
                                </div> : ""

                            }
                        </div>
                    </Card>
                    }

                    {/* Review & Submit — Phase C.7.4: restructured from a 2-column layout (declaration
                        checkboxes left, CAPTCHA + final buttons stacked on the right) into one clear
                        top-to-bottom flow — verify details → CAPTCHA → submit — matching the phase's
                        own requested hierarchy and directly addressing the "detached CAPTCHA"/
                        "detached Back to Login/Register actions" findings from the live baseline
                        review (the CAPTCHA previously sat in a fixed 200px-wide right column, visually
                        disconnected from the declaration checkboxes and from the submit buttons below
                        it). Every field/handler/disabled-condition below is byte-identical to before —
                        only the surrounding layout markup changed. The CAPTCHA's own `<table>` markup
                        is replaced with a plain flex row (image + input + refresh) — same img src,
                        same onChange/onClick, same error state. */}
                    <Card header={<h2 className="displayInGrid"><Text k="registration.reviewSubmitHeading" /></h2>}>
                        <div className="row w-100 m-0 pt-3">
                            <div className="col-12 termsCheckboxAlign">
                                <h3 className="form-section-title"><div className='displayInGrid'><Text k="registration.declarationHeading" /></div></h3>
                                {/* Phase C.7.4A (§8 Declaration UX): each declaration now sits in its
                                    own block-level row (.ent-declaration-row) instead of both
                                    InputChecks sitting side-by-side as inline-flex siblings — live-
                                    confirmed the two previously ran onto one compressed line at
                                    desktop widths. Same is_DateConfirm/is_ConsentAccepted state,
                                    same onChange/checked/error/legal-link markup, unchanged. */}
                                <div className="ent-declaration-row">
                                <InputCheck
                                    id="is_DateConfirm"
                                    type="checkbox"
                                    /* Phase C.7.4B (§8/§19 root-cause fix): dropped `color-secondary-text` (a
                                       dark-green class, Sprint 4) — this phase asks for "normal dark neutral"
                                       declaration copy; with no class here the text now inherits the
                                       surrounding normal text color instead. */
                                    /* Phase C.7.4D-R1 (§4): ent-required-asterisk gives this a small
                                       explicit margin — was rendering with zero gap after the label
                                       text (no space in the source between the two elements). */
                                    label={<div className='displayInGrid verifyDetails' style={{ fontSize: "14px" }}><div><Text k="registration.verifyDetailsLabel" /><span className="color-red ent-required-asterisk">*</span></div></div>}
                                    name="is_DateConfirm"
                                    onChange={() => this.onChangeCheckBox("is_DateConfirm")}
                                    checked={this.state.is_DateConfirm ? this.state.is_DateConfirm : false}
                                />
                                {this.state.is_DateConfirmError !== "" ? <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.is_DateConfirmError}</label> : ""}
                                </div>
                                <div className="ent-declaration-row">
                                {/* Sprint 2.2 (Privacy & Consent Foundation) */}
                                <InputCheck
                                    id="is_ConsentAccepted"
                                    type="checkbox"
                                    /* Phase C.7.4C (§9): Privacy Policy/Terms & Conditions now open in
                                       PublicFooter's existing modern Drawer (via the footerRef above)
                                       instead of navigating away to the legacy /privacypolicy and
                                       /termsandconditions routes in a new tab — the candidate stays on
                                       Form 1 with all entered data intact, exactly like the homepage's
                                       own Important Links. Same legal content, same
                                       getPortalConfigurationByKey() fetch, same routes still exist and
                                       still work for direct access (§10) — only this in-page link's
                                       behavior changed, from <a href target=_blank> to a button opening
                                       the shared drawer. */
                                    label={<div className='displayInGrid verifyDetails' style={{ fontSize: "14px" }}><div><Text k="registration.consentPrefix" /> <button type="button" className="ent-declaration-link" onClick={(e) => { e.preventDefault(); this.footerRef.current.showDrawer("privacypolicy"); }}><Text k="registration.privacyPolicyLink" /></button> <Text k="registration.consentAnd" /> <button type="button" className="ent-declaration-link" onClick={(e) => { e.preventDefault(); this.footerRef.current.showDrawer("termsandconditions"); }}><Text k="registration.termsConditionsLink" /></button>.<span className="color-red ent-required-asterisk">*</span></div></div>}
                                    name="is_ConsentAccepted"
                                    onChange={() => this.onChangeCheckBox("is_ConsentAccepted")}
                                    checked={this.state.is_ConsentAccepted ? this.state.is_ConsentAccepted : false}
                                />
                                {this.state.is_ConsentAcceptedError !== "" ? <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.is_ConsentAcceptedError}</label> : ""}
                                </div>
                            </div>

                            <div className="col-12">
                                <h3 className="form-section-title"><div className='displayInGrid'><Text k="registration.captchaHeading" /></div></h3>
                                <div className="ent-captcha-row">
                                    <img className="ent-captcha-image" src={`data:image/png;base64,${this.state.captcha.Captcha ? this.state.captcha.Captcha : ""}`} alt='Captcha' />
                                    <button type="button" className="ent-captcha-refresh" onClick={this.onRefresh} aria-label={tr('registration.refreshCaptchaAriaLabel')}>
                                        <img src={captchaReload} height="20" width="20" alt="" aria-hidden="true" />
                                    </button>
                                    <div className="ent-captcha-input">
                                        <MyInput
                                            key="captchaText"
                                            type="text"
                                            value={this.state.captchaText}
                                            name="captchaText"
                                            onChange={this.onTextChange}
                                            placeholder={tr('registration.enterCaptchaCodeLabel')}
                                            heading={<div className='displayInGrid'><Text k="registration.enterCaptchaCodeLabel" /></div>}
                                            isRequired={true}
                                            errorState={this.state.captchaTextError}
                                            errorMessage={this.state.captchaTextError}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                {/* Phase C.7.4A (§9): the standalone "Final Registration" label was
                                    visually detached and added no hierarchy the REGISTER button itself
                                    doesn't already convey — removed per this phase's own preferred
                                    treatment ("remove the redundant label if it has no functional
                                    purpose"). No handler/state/registration.finalRegistrationHeading
                                    consumer elsewhere was affected — this was its only use. */}
                                <div className="d-flex justify-content-between  button-global-group btn2 justify-content-center ent-final-actions">
                                    <Button
                                        onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.login.path) }}
                                        className="button-global button-outline autoHeight mw125 mt10"
                                        value={<div className='displayInGrid'><Text k="registration.backToLoginButton" /></div>}
                                    ></Button>



                                    {this.state.config.is_Aadhar_Authentication == true && (
                                        <Button
                                            disabled={!this.state.is_DateConfirm || !this.state.is_ConsentAccepted || this.state.aadharOtpVerity == false}
                                            style={{ cursor: (!this.state.is_DateConfirm || !this.state.is_ConsentAccepted || this.state.aadharOtpVerity == false) ? "not-allowed" : "" }}
                                            // type="submit"
                                            onClick={this.handleOpenModal}
                                            className="button-global button-primary autoHeight mw125 mt10"
                                            value={<div className='displayInGrid'><Text k="registration.registerButton" /></div>}
                                        ></Button>

                                    )}

                                    {this.state.config.is_Aadhar_Authentication == false && (
                                        <Button
                                            disabled={!this.state.is_DateConfirm || !this.state.is_ConsentAccepted ||
                                                ((this.state.mobileOtpVerificationEnabled || this.state.emailOtpVerificationEnabled) && !this.state.identityVerificationToken)}
                                            style={{
                                                cursor: (!this.state.is_DateConfirm || !this.state.is_ConsentAccepted ||
                                                    ((this.state.mobileOtpVerificationEnabled || this.state.emailOtpVerificationEnabled) && !this.state.identityVerificationToken)) ? "not-allowed" : ""
                                            }}
                                            // type="submit"
                                            onClick={this.handleOpenModal}
                                            className="button-global button-primary autoHeight mw125 mt10"
                                            value={<div className='displayInGrid'><Text k="registration.registerButton" /></div>}
                                        ></Button>
                                    )}

                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
                {this.state.isLoading && <LoadingSpinner />}

            </div >
            {/* Phase C.7.4A (§10 footer modernization): className is a new, optional, additive
                PublicFooter prop (see that component) — every other consumer still omits it. */}
            {/* Phase C.7.4B (§10): hideLinkBar reuses the exact same prop the homepage already uses to
                suppress PublicFooter's 5-button legal/nav row (its own "Important Links" card covers
                that navigation there) — Registration doesn't need the full row either, since Privacy
                Policy/Terms & Conditions remain directly reachable from the declaration above. The
                browser/support-compatibility text and the gradient background are unaffected. No new
                prop, no markup duplication, no route removed — the same links still exist at their
                same destinations, just not repeated in this page's footer. */}
            <PublicFooter ref={this.footerRef} className="ent-registration-footer" hideLinkBar />

            <Modal
                title={tr('registration.confirmRegistrationModalTitle')}
                visible={this.state.showModal}
                onCancel={this.handleCloseModal}
                className="confirm-registration-modal modal-global"
                footer={[
                    <div className="button-global-group btn2 d-flex justify-content-between">
                        <Button key="back"
                            onClick={this.handleCloseModal}
                            className="button-global button-border "
                            value={<div className='displayInGrid'><Text k="registration.cancelButton" /></div>}
                        >
                        </Button>
                        <Button key="submit"
                            type="primary"
                            className="button-global button-primary autoHeight "
                            value={<div className='displayInGrid'><Text k="registration.submitButton" /></div>}
                            onClick={(e) => this.handleSubmitModal(e)}>
                        </Button>

                    </div>

                ]}
            >
                <p ><Text k="registration.modalReviewInfo" /></p>

                <p ><Text k="registration.modalConfirmInfo" /></p>

                <p ><Text k="registration.modalNoChangeInfo" /></p>

                <p ><Text k="registration.modalCancelInstructionPrefix" /> <span className="color-secondary-text" ><Text k="registration.cancelButton" /></span> <Text k="registration.modalCancelInstructionMiddle" /> <span className="color-primary-text" ><Text k="registration.submitButton" /></span> <Text k="registration.modalCancelInstructionSuffix" /></p>
            </Modal>


        </>
        );
    }
}

